import { render, staticRenderFns } from "./commentAudit.vue?vue&type=template&id=e789c830&scoped=true"
import script from "./commentAudit.vue?vue&type=script&lang=ts"
export * from "./commentAudit.vue?vue&type=script&lang=ts"
import style0 from "./commentAudit.vue?vue&type=style&index=0&id=e789c830&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e789c830",
  null
  
)

export default component.exports